import { list as adProviderList } from './AdProvider';
import viSpeaker from '../icons/viSpeaker';
import viTv from '../icons/viTv';
import viHelp from '../icons/viHelp';

/**
 * List of supported Media Formats
 * @param options object of options to build the list
 * @param options.includeEmpty boolean to include an empty name/value pair at the beginning
 * @param options.emptyData object of data to spread into the empty name/value pair if includeEmpty is true
 */
export function list(options = {}) {
  const list = [
    {
      label: 'Audio',
      value: 'audio',
      // allow all ad providers for this media format
      adProviders: adProviderList().map(adProvider => adProvider.value),
    },
    {
      label: 'Visual',
      value: 'visual',
      // allowed ad providers for this media format (all but Koddi)
      adProviders: adProviderList()
        .filter(adProvider => adProvider.value !== 'koddi')
        .map(adProvider => adProvider.value),
    },
  ];

  if (options.includeEmpty === true) {
    const emptyData = options.emptyData ?? {};

    list.unshift({
      label: '',
      value: '',
      adProviders: [],
      ...emptyData,
    });
  }

  return list;
}

/**
 * Get icon for the media format
 */
export function getIcon(mediaFormat) {
  switch (mediaFormat) {
    case 'visual':
      return viTv;

    case 'audio':
      return viSpeaker;

    default:
      return viHelp;
  }
}

/**
 * Get tooltip for the media format
 */
export function getTooltip(mediaFormat) {
  switch (mediaFormat) {
    case 'visual':
      return 'Visual';

    case 'audio':
      return 'Audio';

    default:
      return 'Unknown';
  }
}

export default {
  list,
  getIcon,
  getTooltip,
};
